import { Component, forwardRef, Input, OnInit } from "@angular/core";
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from "@angular/forms";
import * as moment from "moment";

export const V4_RANGE_PICKER_VALUE_ACCESSOR = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => V4RangePickerComponent),
  multi: true,
};

@Component({
  selector: "v4-range-picker",
  templateUrl: "./range-picker.component.html",
  styleUrls: ["./range-picker.component.scss"],
  providers: [V4_RANGE_PICKER_VALUE_ACCESSOR],
})
export class V4RangePickerComponent implements OnInit, ControlValueAccessor {
  @Input() showControl = true;
  @Input() placeholder;
  value = [new Date(), new Date()];
  _registerOnChange: (value: any) => void = (_: any) => {};
  constructor() {}

  ngOnInit() {}

  onPrevDate() {
    this.value = (this.value || []).map((date) => moment(date).subtract(1, "day").toDate());
    this._registerOnChange(this.value);
  }

  onNextDate() {
    this.value = (this.value || []).map((date) => moment(date).add(1, "day").toDate());
    this._registerOnChange(this.value);
  }

  onValueChange() {
    this._registerOnChange(this.value);
  }

  registerOnChange(fn: any): void {
    this._registerOnChange = fn;
  }

  registerOnTouched(fn: any): void {}

  writeValue(value: any): void {
    this.value = value;
  }
}
